module.exports = __webpack_public_path__ + "static/media/DB.d51bef57.svg";